import * as _ from 'underscore';
import * as $ from 'jquery';
const Backbone = require('backbone');

import { IGlob } from './../Glob';
import * as reactGlobalClick from '../../../../_common/platform/ts/reactGlobalClick';

import BaseStore from '../../../../_common/platform/ts/BaseStore';

import { Constants } from '../../../../_common/platform/ts/Constants';

const Cookies = require('pdc-platform-cookies');

import * as pageVisibilityChange from '../../../../_common/platform/ts/pageVisibilityChange';
import { IValuesCollection } from '../../../../_common/platform/ts/appTheme';

import { config } from '../config';
import * as mainRouter from '../mainRouter';
import * as initialRouter from '../initialRouter';
import serializeWorkspace from '../../../../_common/platform/ts/serializeWorkspace';

import { AppDispatcher as Dispatcher } from '../dispatcher/AppDispatcher';
import { Action, AppActions, I, check as checkAction } from '../actions/AppActions';

import { I as IW } from '../actions/WorkspaceActions';

import { IGlobalObject } from '../main';
import { IErrorMessage, IURLQuery, IWidgetState } from '../Interfaces';
import { URL_KEYS } from '../../../../_common/platform/tsx/filtering/Constants';

import {
    encodeParameterForURL,
    encodeParametersForURL
} from '../../../../_common/platform/tsx/filtering/FilterUtilities';

const DEFAULT_WORKSPACES = 'default-workspaces';
const KEY_TIME_STAMPS = 'time-stamps';
const LOCAL_STORAGE_LIMIT = 5000000; //Max is 5242883 characters in Chrome and Firefox, but about 120000 in Internet Explorer.
const LOCAL_STORAGE_KEY_APPLICATION_NAME = 'pdc-wwPlatform-';
const LOCAL_STORAGE_KEY_SIZE = LOCAL_STORAGE_KEY_APPLICATION_NAME + 'stored-data-size';
const LAST_NAVIGATION_BAR_HEIGHT = 'last-navigation-bar-height';

const ON_TAB_CONTENT_STATE_CHANGED = 'tab-content-state-changed';

export interface IAuthData {
    displayName?: string;
    userid?: number;
    picture?: string;
}

export interface ITab {
    id?: number;
    cid?: number;
    workspaceID?: number;
    visible?: boolean;
    title?: string;
    widget?: number;
    originTab?: number;
    widgetTheme?;
    distractFree?: true;
    widgetState?: IWidgetState;
    query?: IURLQuery;
    urlOptions?: any;
    mode?: string;
    lastShowTime?: number;
    isDefault?: boolean;
    contentChanged?: number[];
    openedInternaly?: boolean;

    stateId?; //Maybe is not used.
}

export interface IAppState {
    time: any;

    authorized: boolean;
    initialized: boolean;
    loading: boolean;

    authData: IAuthData;

    showDirsWorkspaces: boolean;
    showDirsTemplates: boolean;
    showWorkspaceEditView: boolean;
    showWorkspaceView: boolean;
    showTemplateEdit: boolean;
    //showUserSettingsView: boolean;
    showDirPermissions: boolean;
    showWidgetEdit: boolean;
    showSignInForm?: boolean;
    showErrorForm?: IErrorMessage;

    tabDisplay: number;
    theme?: IValuesCollection;

    tabs: ITab[];
    maximizedTab?: ITab;

    pageIsVisible: boolean;

    showComponent?: boolean;
    componentModuleName?: string;
    componentProps?: any;
    homeFolderId: number;
}

export class AppStore extends BaseStore<IAppState, AppActions, Dispatcher, IGlob> {
    public static getInitialState(): IAppState {
        return {
            time: new Date(),

            authorized: false,
            initialized: false,
            loading: false,

            authData: {},

            showDirsWorkspaces: false,
            showDirsTemplates: false,
            showWorkspaceEditView: false,
            showWorkspaceView: false,
            showTemplateEdit: false,
            //showUserSettingsView: false,
            showDirPermissions: false,

            showWidgetEdit: false,

            tabDisplay: 0,
            tabs: [this.getEmptyTab()],
            maximizedTab: null,

            pageIsVisible: pageVisibilityChange.isVisible(),
            homeFolderId: -1
        };
    }

    private static getEmptyTab(shift = 0): ITab {
        const newID = new Date().valueOf() + shift;

        return {
            id: newID,
            cid: newID,
            workspaceID: null,
            widget: null,
            originTab: null,
            contentChanged: null
        };
    }

    public _state: IAppState;
    public glob: IGlobalObject;

    public serializeDataToStore(data: IAppState): string {
        const obj = {
            tabs: _.map(data.tabs, (tab) => {
                let tabToStore: ITab;

                if (tab != null) {
                    tabToStore = {
                        cid: tab.cid,
                        workspaceID: tab.workspaceID,
                        id: tab.id,
                        originTab: tab.originTab,
                        widget: tab.widget,
                        title: tab.title,
                        query: tab.query,
                        urlOptions: tab.urlOptions,
                        isDefault: tab.isDefault
                    };
                }

                return tabToStore;
            }),
            tabDisplay: data.tabDisplay
        };

        return JSON.stringify(obj);
    }

    public readCache() {
        super.readCache();

        const defaultWorkspaces = this.getDefaultWorkspaces();
        const location = window.location;
        const hash = location.hash.replace('#', '');

        if (defaultWorkspaces.length > 0) {
            const storedDefaultWorkspaces = this.getFromLocalStorage(DEFAULT_WORKSPACES);
            const defaultWorkspacesStr = JSON.stringify(defaultWorkspaces);

            if (storedDefaultWorkspaces == null || storedDefaultWorkspaces !== defaultWorkspacesStr) {
                this.saveToLocalStorage(DEFAULT_WORKSPACES, defaultWorkspacesStr);

                if (defaultWorkspaces.length > 0) {
                    this.applyDefaultWorkspaces(defaultWorkspaces);
                    this.saveState();

                    // OE -- if there was something to open from URL - do it
                    //       using hash value after opening of default workspaces
                    // WorkItem [122610]: Issue is not opened form mail message when user is not logged in

                    // VR (Issue 70588: Wellcome WS is not shown for first Login):
                    // except: #ResetPW and #NewUser
                    let route;

                    if (
                        hash &&
                        hash.length > 0 &&
                        hash.indexOf('NewUser') < 0 &&
                        hash.indexOf('ResetPW') < 0 &&
                        hash.indexOf('ApproveDevice') < 0
                    ) {
                        route = hash;
                    } else {
                        route = 'tabs/0/workspaces/' + defaultWorkspaces[0];
                    }

                    this.glob.mainRouter.navigate(route, {
                        trigger: false,
                        replace: true
                    });
                }
            }
        } else {
            this.removeFromLocalStorage(DEFAULT_WORKSPACES);
        }
    }

    public getAuthenticationData() {
        return this._state.authData;
    }

    public getAutorized() {
        return this._state.authorized;
    }

    public getTabs() {
        return this._state.tabs;
    }

    public getTabInfo(id: number) {
        const tabs = this._state.tabs;

        for (let index = 0; index < tabs.length; index++) {
            const tab = tabs[index];

            if (tab.id === id || tab.cid === id) {
                return {
                    tab: tab,
                    tabIndex: index
                };
            }
        }

        return {};
    }

    public getCurrentTab() {
        if (this._state.maximizedTab != null) {
            return this._state.maximizedTab;
        }

        return this._state.tabs[this._state.tabDisplay];
    }

    private setCurrentTab(obj: ITab) {
        if (this._state.maximizedTab != null) {
            this._state.maximizedTab = obj;
        } else {
            this._state.tabs[this._state.tabDisplay] = obj;
        }
    }

    public getCurrentTabID() {
        if (this._state.maximizedTab != null) {
            return this._state.maximizedTab.id;
        }

        const currentTab = this._state.tabs[this._state.tabDisplay];

        return currentTab && (currentTab.id || currentTab.cid);
    }

    private updateTime() {
        this._state.time = new Date();
    }

    private getPath() {
        if (config.AUTH_COOKIE_PATH != null) {
            return config.AUTH_COOKIE_PATH;
        } else {
            return location.pathname;
        }
    }

    private setTab(
        tabIndex: number,
        tabTitle: string,
        workspaceID: number,
        widgetID: number,
        originTab: number,
        appMode: boolean,
        theme: IValuesCollection,
        query: IURLQuery,
        urlOptions: IW.IWorkspaceViewOpenOptions,
        openedInternaly: boolean
    ) {
        const tab = this._state.tabs[tabIndex] || {};

        if (tab.id == null || tab.workspaceID !== workspaceID) {
            tab.id = new Date().valueOf();
        }

        if (widgetID != null) {
            tab.widget = widgetID;
        }

        if (originTab != null) {
            tab.originTab = originTab;
        }

        if (theme != null) {
            tab.widgetTheme = theme;
        }

        if (appMode) {
            tab.distractFree = true;
        } else {
            delete tab.distractFree;
        }

        if (tabTitle != null) {
            tab.title = tabTitle;
        } else {
            delete tab.title;
        }

        if (openedInternaly) {
            tab.openedInternaly = true;
        }

        if (query != null) {
            tab.query = query;
        } else {
            // See WI 141456.
            if (tab.query != null && tab.workspaceID !== workspaceID) {
                // || !openedInternaly
                delete tab.query; // Delete it if another workspace opened in the tab.
            }
        }

        if (urlOptions != null) {
            tab.urlOptions = urlOptions;
        } else if (tab.workspaceID !== workspaceID) {
            delete tab.urlOptions; // Delete it if another workspace opened in the tab.
        }

        tab.workspaceID = workspaceID;
        this._state.tabs[tabIndex] = tab;
    }

    private initialLoad() {
        if (this._state.initialized === true) {
            return;
        }

        this._state.showErrorForm = null;
        this._state.loading = true;
    }

    private showErrorForm(error: IErrorMessage) {
        this._state.showErrorForm = error;
    }

    private initialLoadFinish(authorized: boolean) {
        this._state.loading = false;

        this._state.initialized = true;
        this._state.authorized = authorized;
    }

    public initBackboneHistory(router) {
        this.glob.mainRouter = router;

        Backbone.history.start({
            root: config.ROUTER_ROOT,
            pushState: false
        });

        this.initBackboneHistory = (router) => {
            Backbone.history.stop();

            this.glob.mainRouter = router;

            Backbone.history.start({
                root: config.ROUTER_ROOT,
                pushState: false
            });
        };
    }

    private getUserName(displayName: string) {
        return displayName?.toLowerCase().replace(/ /g, '');
    }

    private getLocalStorageKey() {
        if (this.glob.userId != null) {
            return LOCAL_STORAGE_KEY_APPLICATION_NAME + this.glob.userId + '-';
        }

        return;
    }

    public getFromLocalStorage(key: string): string {
        if (window.localStorage != null) {
            const appkey = this.getLocalStorageKey();

            if (appkey != null) {
                return window.localStorage.getItem(appkey + key);
            }
        }

        return undefined;
    }

    public getLastNavigationBarHeight() {
        const result = this.getFromLocalStorage(LAST_NAVIGATION_BAR_HEIGHT);

        if (result != null) {
            return parseInt(result, 10);
        }

        return 0;
    }

    public saveLastNavigationBarHeight(value: number) {
        this.saveToLocalStorage(LAST_NAVIGATION_BAR_HEIGHT, value.toString());
    }

    public saveToLocalStorage(key: string, data: string) {
        if (window.localStorage == null || data == null) {
            return;
        }

        const appkey = this.getLocalStorageKey();

        if (appkey == null) {
            return;
        }

        const dataKey = appkey + key;

        let size = data.length + dataKey.length;

        if (size > LOCAL_STORAGE_LIMIT) {
            this.glob.AppActions.showNotification_Fail(`Data for '${key}' cannot be saved into Local Storage`);
            return;
        }

        const storedSize = parseInt(window.localStorage.getItem(LOCAL_STORAGE_KEY_SIZE));

        let timeStamps: { [key: string]: number };

        if (isNaN(storedSize)) {
            window.localStorage.clear();
        } else {
            size += storedSize;
        }

        const timeStampsKey = appkey + KEY_TIME_STAMPS;
        const timeStampsString = window.localStorage.getItem(timeStampsKey);

        if (timeStampsString == null || timeStampsString === '') {
            timeStamps = {};
        } else {
            timeStamps = JSON.parse(timeStampsString);

            const oldItem = window.localStorage.getItem(dataKey);

            if (oldItem != null) {
                size -= oldItem.length + dataKey.length;
                delete timeStamps[dataKey];
                window.localStorage.removeItem(dataKey);
            }

            while (size > LOCAL_STORAGE_LIMIT) {
                // Clean up records by their age from Time Stamps.
                const newTimeStamps: { [key: string]: number } = {};
                const timeStampValues = _.values(timeStamps).sort((a, b) => a - b);

                let numberOfItemsToDelete = 1;

                if (timeStampValues.length > 4) {
                    numberOfItemsToDelete = Math.floor(timeStampValues.length / 4);
                }

                timeStampValues.splice(0, numberOfItemsToDelete);

                for (const tsKey in timeStamps) {
                    if (timeStampValues.indexOf(timeStamps[tsKey]) < 0) {
                        const itemToRemove = window.localStorage.getItem(tsKey);

                        if (itemToRemove != null) {
                            size -= itemToRemove.length + tsKey.length;
                        }

                        window.localStorage.removeItem(tsKey);
                    } else {
                        newTimeStamps[tsKey] = timeStamps[tsKey];
                    }
                }

                timeStamps = newTimeStamps;
            }
        }

        let saveResult = false;

        try {
            window.localStorage.setItem(dataKey, data);
            saveResult = true;
        } catch (e) {
            console.log('Fail to save data to Local Storage: ' + e);
        }

        // To save records from cleaning, put here their keys.
        if (saveResult && key !== 'store-app' && key !== 'store-app-settings' && key !== 'default-workspaces') {
            timeStamps[dataKey] = new Date().getTime();

            try {
                window.localStorage.setItem(timeStampsKey, JSON.stringify(timeStamps));
            } catch (e) {
                saveResult = false;
                window.localStorage.removeItem(dataKey);
                console.log('Fail to save Time Stamps to Local Storage: ' + e);
            }
        }

        if (saveResult) {
            window.localStorage.setItem(LOCAL_STORAGE_KEY_SIZE, size.toString());
        }
    }

    private saveTimeStamps(key: string, timeStamps: { [key: string]: number }) {
        let result = false;

        if (_.isEmpty(timeStamps)) {
            window.localStorage.removeItem(key);
            result = true;
        } else {
            try {
                window.localStorage.setItem(key, JSON.stringify(timeStamps));
                result = true;
            } catch (e) {
                window.localStorage.clear();
                console.log('Fail to save Time Stamps to Local Storage: ' + e);
            }
        }

        return result;
    }

    public removeFromLocalStorage(key: string): void {
        if (window.localStorage != null) {
            const appkey = this.getLocalStorageKey();

            if (appkey != null) {
                const dataKey = appkey + key;
                const timeStampsKey = appkey + KEY_TIME_STAMPS;
                const timeStampsString = window.localStorage.getItem(timeStampsKey);

                window.localStorage.removeItem(dataKey);

                if (timeStampsString != null) {
                    const timeStamps = JSON.parse(timeStampsString);

                    if (timeStamps[dataKey] != null) {
                        delete timeStamps[dataKey];
                        this.saveTimeStamps(timeStampsKey, timeStamps);
                    }
                }
            }
        }
    }

    private authFinish(displayName: string, userid: number, userToken: string, picture?: string) {
        this.glob.userId = this.getUserName(displayName);
        this.glob.userToken = userToken;

        this.actions.storeCacheRead();

        this._state.initialized = true;
        this._state.authorized = true;

        this._state.authData.displayName = displayName;
        this._state.authData.userid = userid;
        this._state.authData.picture = picture;

        Backbone.history.handlers = [];

        this.initBackboneHistory(mainRouter.get(this.glob, this.actions, this.glob.routerExtender));

        if (config.SINGLE_WORKSPACE != null) {
            //const route = 'tabs/1/workspaces/' + defaultWorkspaceDescription.main;
            //LL: 12.04.21: "main" (that is "Show First") is not used now:

            let route = 'tabs/1/workspaces/';

            const defaultWorkspaces = this.getDefaultWorkspaces();

            if (defaultWorkspaces.length > 0) {
                route += defaultWorkspaces[0];
            }

            this.glob.mainRouter.navigate(route, {
                trigger: false,
                replace: true
            });
        }

        this.glob.ServerEvents.connect(userid);

        this.startTokenRefreshPooling(userToken);
    }

    private startTokenRefreshPooling = (userToken: string) => {
        const tokenRefreshInterval = this.glob.SettingsStore.getTokenRefreshInterval();
        if (tokenRefreshInterval != null && tokenRefreshInterval > 0) {
            setInterval(() => {
                this.actions.authRefreshToken(userToken);
            }, tokenRefreshInterval * 1000);
        }
    };

    private unauthorized() {
        this.glob.userId = null;
        this.glob.userToken = null;
        this._state.authorized = false;
        this._state.authData = {};
    }

    protected signOut() {
        this._state = AppStore.getInitialState();

        this.unauthorized();

        this.glob.ServerEvents.disconnect();

        this._state.initialized = true; //getInitialState sets it to false, but it makes app hang after signing out.

        Cookies.expire(config.AUTH_COOKIE_NAME, {
            path: this.getPath()
        });

        Backbone.history.handlers = [];

        if (window.localStorage != null) {
            window.localStorage.clear();
        }

        this.initBackboneHistory(initialRouter.get(this.glob, this.actions, this.glob.initialRouterExtender));
    }

    private getDefaultWorkspaces(): number[] {
        const defaultWorkspaceDescription = this.glob.SettingsStore.getDefaultWorkspaceValue();

        if (defaultWorkspaceDescription == null) {
            return [];
        }

        const workspace = defaultWorkspaceDescription.workspace;

        let result: number[] = [];

        if (typeof workspace === 'number') {
            result.push(workspace);
        } else if (workspace != null) {
            for (let key in workspace) {
                result.push(parseInt(key, 10));
            }

            if (result.length > 0) {
                const workspaceOrder = defaultWorkspaceDescription.workspaceOrder;

                if (workspaceOrder != null) {
                    let maxOrder = 0;

                    _.each(workspaceOrder, (num) => {
                        if (num > maxOrder) {
                            maxOrder = num;
                        }
                    });

                    maxOrder++;

                    result = _.sortBy(result, (id) => {
                        return workspaceOrder[id] != null ? workspaceOrder[id] : maxOrder;
                    });
                }
            }
        }

        return result;
    }

    private applyDefaultWorkspaces(defaultWorkspaces: number[]) {
        if (defaultWorkspaces.length > 0) {
            const useTabsMode = this.glob.SettingsStore.useTabsMode();

            if (useTabsMode) {
                this._state.tabs = _.map(defaultWorkspaces, (id, i) => {
                    const tab = AppStore.getEmptyTab(i);

                    tab.workspaceID = id;
                    tab.isDefault = true;

                    return tab;
                });

                defaultWorkspaces.forEach((id) => {
                    this.actions.workspaceViewLoadContent(id, false, null, true);
                });
            } else {
                const tab = AppStore.getEmptyTab(0);

                tab.workspaceID = defaultWorkspaces[0];
                this.actions.workspaceViewLoadContent(tab.workspaceID, false, null, true);
            }

            this._state.tabDisplay = 0;
        }
    }

    private mainViewShow() {
        const { tabs, tabDisplay } = this._state;

        if (tabs.length === 1 && tabDisplay === 0 && tabs[0] != null && tabs[0].workspaceID == null) {
            const defaultWorkspaces = this.getDefaultWorkspaces();

            this.applyDefaultWorkspaces(defaultWorkspaces);
        }

        this.navigateToTab(tabDisplay, tabs[tabDisplay] && tabs[tabDisplay].workspaceID);
    }

    private mainViewHide() {}

    private showDirsWorkspaces() {
        this._state.showDirsWorkspaces = true;
    }

    private hideDirsWorkspaces() {
        this._state.showDirsWorkspaces = false;
    }

    private showDirsTemplates() {
        this._state.showDirsTemplates = true;
    }

    private hideDirsTemplates() {
        this._state.showDirsTemplates = false;
    }

    private workspaceShow() {
        this._state.showWorkspaceEditView = true;
    }

    private workspaceHide(id: number) {
        this._state.showWorkspaceEditView = false;

        reactGlobalClick.trigger(null, 1);
        reactGlobalClick.cancel();
    }

    private workspaceViewShow(id) {
        this._state.showWorkspaceView = true;
    }

    private workspaceViewHide(id) {
        this._state.showWorkspaceView = false;
    }

    private workspaceViewOpen(
        id: number,
        tab: number | { tabIndex: number; tabTitle: string },
        widgetID: number = null,
        originTab: number = null,
        options: IW.IWorkspaceViewOpenOptions = null,
        theme: IValuesCollection,
        query: IURLQuery
    ) {
        if (this._state.maximizedTab != null) {
            return;
        }

        const distractFree = options != null ? options.distractFree : false;
        const useTabsMode = this.glob.SettingsStore.useTabsMode();

        let tabIndex: number;
        let tabTitle: string;
        let openedInternaly = false;

        if (useTabsMode) {
            if (typeof tab === 'number') {
                tabIndex = tab;
            } else if (tab != null) {
                tabIndex = tab.tabIndex;
                tabTitle = tab.tabTitle;
                openedInternaly = true;
            }

            if (tabIndex == null && distractFree) {
                tabIndex = this._state.tabDisplay;
            }

            if (tabIndex === -1) {
                tabIndex = this._state.tabDisplay;
            }
        } else {
            tabIndex = 0;

            if (tab != null && typeof tab !== 'number') {
                tabTitle = tab.tabTitle;
                openedInternaly = true;
            }
        }

        if (tabTitle == null && query != null) {
            const tabTitleParam = query[URL_KEYS.TabTitle];

            if (tabTitleParam != null) {
                tabTitle =
                    Array.isArray(tabTitleParam.val) && tabTitleParam.val.length === 1
                        ? tabTitleParam.val[0]
                        : undefined;

                if (tabTitle != null) {
                    delete query[URL_KEYS.TabTitle];
                }
            }
        }

        const tabs = this._state.tabs;

        if (id != null) {
            if (tabIndex != null) {
                for (let index = 0; index < tabs.length; index++) {
                    if (index !== tabIndex) {
                        const tabObj = tabs[index];

                        if (tabObj.workspaceID === id && tabObj.mode === 'widgets') {
                            this.actions.showNotification_Warning(
                                'Editing of this Workspace is started in another tab. Any changes of the Workspace will be applied to ALL places it is opened.',
                                null
                            );
                            break;
                        }
                    }
                }
            } else if (widgetID == null && originTab == null) {
                // Find an existing workspace to activate.
                for (let index = 0; index < tabs.length; index++) {
                    const tabObj = tabs[index];

                    if (tabObj.workspaceID === id) {
                        tabIndex = index;
                        break;
                    }
                }
            }
        }

        if (tabIndex == null || tabIndex >= tabs.length) {
            tabs.push(AppStore.getEmptyTab(null));
            tabIndex = tabs.length - 1;

            if (tab != null && typeof tab === 'object') {
                tab.tabIndex = tabIndex;
            } else {
                tab = tabIndex;
            }
        }

        if (id == null) {
            id = tabs[tabIndex] && tabs[tabIndex].workspaceID;
        }

        this._state.tabDisplay = tabIndex;

        // Put DrillDown options to widgetState to be used in Workspace.didMount
        if (options != null && options.drilldown != null) {
            this.applyDrillDown(id, options.drilldown);
        }

        this.setTab(tabIndex, tabTitle, id, widgetID, originTab, distractFree, theme, query, options, openedInternaly);
        tabs[tabIndex].lastShowTime = new Date().getTime();

        // if (!openedInternaly && query != null) {
        //     // When user opens a workpace by a URL Link with a query, the applied query is dropped from URL here.
        //     this.navigateToTab(tabIndex, id, true, true, false);
        // } else {
        //     this.navigateToTab(tabIndex, id, true, false);
        // }

        this.navigateToTab(tabIndex, id, true, false);
    }

    private dropWorkspaceQuery(tabID: number) {
        const { tab, tabIndex } = this.getTabInfo(tabID);

        if (tab != null && tab.query != null) {
            delete tab.query;
            this.navigateToTab(tabIndex, tab.workspaceID, true, true, false);
        }
    }

    private workspaceWidgetViewOpen(workspace, widget, stateId, data, query) {
        let widgetState = $.extend(true, {}, data);

        if (query != null) {
            widgetState = $.extend(true, widgetState, {
                query: query
            });
        }

        this._state.maximizedTab = {
            workspaceID: workspace,
            widget: widget,
            id: new Date().valueOf(),
            distractFree: true,
            stateId: stateId,
            widgetState: widgetState
        };
    }

    private navigateToTab(tabIndex: number, id = null, replace = false, trigger = true, includeQuery = true) {
        if (this._state.maximizedTab != null || this._state.authorized !== true) {
            return;
        }

        this.glob.AppActions.cleanWidgetNotifications(null);

        // Remember active tabIndex.
        this._state.tabDisplay = tabIndex;

        const tab = this._state.tabs[tabIndex];

        let route = 'tabs/' + tabIndex;
        let widget;

        if (tab != null) {
            if (id == null) {
                id = tab.workspaceID;
            }

            widget = tab.widget;
            tab.visible = true;
        }

        if (id != null) {
            route += '/workspaces/' + id;
        }

        if (tab.title != null) {
            route += '/title/' + tab.title;
        }

        if (widget != null) {
            route += '/widgets/' + widget;
        }

        if (tab != null) {
            if (tab.urlOptions != null) {
                if (tab.urlOptions.drilldown != null) {
                    delete tab.urlOptions.drilldown;
                }

                if (!_.isEmpty(tab.urlOptions)) {
                    route += '/data/' + encodeURI(btoa(JSON.stringify(tab.urlOptions)));
                }
            }

            if (tab.query != null && includeQuery) {
                const encodeQuery = _.map(_.keys(tab.query), (key) => {
                    const queryElement = tab.query[key];
                    const attr = encodeParameterForURL(queryElement.attr);
                    const val = encodeParametersForURL(queryElement.val);

                    return `${queryElement.op}(${attr},"${val}")`;
                }).join('&');

                route += '/?' + encodeQuery;
            }
        }

        this.glob.mainRouter.navigate(route, {
            trigger: trigger,
            replace: replace
        });
    }

    //EVG 02.02.2022:
    // 'workspaceBeforeClose' is called on unmounting of Workspace.tsx.
    // It deletes tab of the workspaces except the originTab, and navigates to tabDisplay.
    // 'originTab' is set only when widget is maximized.
    private workspaceBeforeClose(id, originTab: number) {
        this._state.tabs = [...this._state.tabs];

        const close = _.reduce<ITab[], number[]>(
            this._state.tabs,
            (res, obj, i) => {
                if (obj.originTab === originTab) {
                    res.push(i);
                }

                return res;
            },
            []
        );

        _.each(close, (i, shift) => {
            this._state.tabs[i] = AppStore.getEmptyTab(shift);
        });

        this.navigateToTab(this._state.tabDisplay);
    }

    private workspaceViewClose(id: number, tabIndex: number, clearWorkspaceCache: boolean, doNotCloseTab: boolean) {
        if (tabIndex == null || tabIndex >= this._state.tabs.length) {
            return;
        }

        const instance = this.glob.WorkspaceStore.getInstanceState(id);

        if (instance != null && instance.edititngStarted) {
            // See Issue 93274. When a WS is opened in several tabs,
            // all of them but the last one are closed without a promt to save and should not drop edititngStarted.
            const numberOfOpenedWorkspaces = this._state.tabs.reduce((prev, tab) => {
                return tab.workspaceID === id ? prev + 1 : prev;
            }, 0);

            if (numberOfOpenedWorkspaces < 2) {
                instance.edititngStarted = false;
            }
        }

        const closedTab = this._state.tabs[tabIndex];

        if (doNotCloseTab !== true) {
            this._state.tabs = [...this._state.tabs]; // Must be done. Otherwise tabs may be not refreshed.
            this._state.tabs.splice(tabIndex, 1)[0];

            if (this._state.tabs.length === 0) {
                this.addTab();
            } else {
                if (this._state.tabDisplay === tabIndex) {
                    this.navigateToLastShownTab();
                } else if (this._state.tabDisplay > tabIndex) {
                    this._state.tabDisplay -= 1;

                    this.navigateToTab(this._state.tabDisplay);
                }
            }
        }

        if (clearWorkspaceCache !== false) {
            const existingTab = _.find(this._state.tabs, (tab) => {
                return tab.workspaceID === id;
            });

            if (existingTab == null || (closedTab != null && closedTab.originTab == null)) {
                this.actions.workspaceClearCache(id);
            }
        }
    }

    private navigateToLastShownTab() {
        const shownTabs = _.sortBy(this._state.tabs, (tab) => {
            return tab.lastShowTime || 0;
        });

        let tabIndex: number;

        if (shownTabs.length > 0) {
            const lastShownTab = shownTabs[shownTabs.length - 1];

            tabIndex = this._state.tabs.indexOf(lastShownTab);
        } else {
            tabIndex = Math.min(tabIndex, this._state.tabs.length - 1);
        }

        this.navigateToTab(tabIndex);
    }

    private findTabIndex(tabID: { id?: number; cid?: number }) {
        return this._state.tabs.findIndex((tab) => {
            return (tab.workspaceID != null && tab.workspaceID === tabID.id) || tab.cid === tabID.cid;
        });
    }

    private closeAllOpenedTabs(exceptTabIndex: number, closeToTheRight: boolean) {
        if (this._state.tabs == null) {
            return false;
        }

        const newTabs: ITab[] = [];
        const tabsToClose: ITab[] = [];
        const editedTabsToClose: ITab[] = [];

        this._state.tabs.forEach((tab, index) => {
            if (index === exceptTabIndex) {
                newTabs.push({ ...tab });
            } else if (closeToTheRight && index < exceptTabIndex) {
                newTabs.push({ ...tab });
            } else {
                const instance = this.glob.WorkspaceStore.getInstanceState(tab.workspaceID || tab.cid);
                const workspaceIsChanged =
                    (instance != null &&
                        !instance.loading &&
                        instance.data != null &&
                        serializeWorkspace(instance.data, true) !== instance.originalData) ||
                    tab.contentChanged != null;

                if (workspaceIsChanged) {
                    newTabs.push({ ...tab });
                    editedTabsToClose.push({ ...tab });
                } else if (tab.originTab == null && this.glob.SettingsStore.workspaceIsDefault(tab.workspaceID)) {
                    if (
                        _.find(newTabs, (newTab) => {
                            return newTab.workspaceID === tab.workspaceID;
                        }) == null
                    ) {
                        newTabs.push({ ...tab });
                    } else {
                        //Close dublicates.
                        tabsToClose.push({ ...tab });
                    }
                } else {
                    tabsToClose.push({ ...tab });
                }
            }
        });

        if (tabsToClose.length > 0) {
            this._state.tabs = newTabs;

            tabsToClose.forEach((tab) => {
                if (tab.originTab == null) {
                    this.actions.workspaceClearCache(tab.workspaceID || tab.cid);
                }
            });
        }

        if (this._state.tabs.length === 0) {
            this.addTab();
        } else if (editedTabsToClose.length > 0) {
            const tabIndex = this.findTabIndex(editedTabsToClose[0]);

            this.glob.AppActions.showNotification_Warning(
                'To avoid loss of changes close changed workspaces manually, please'
            );
            this.navigateToTab(tabIndex);
        } else if (tabsToClose.length > 0) {
            this.navigateToLastShownTab();
        } else {
            return false;
        }

        return true;
    }

    private templateShow(id) {
        this._state.showTemplateEdit = true;
    }

    private templateHide(id) {
        this._state.showTemplateEdit = false;
    }

    private workspaceRemove(success, id) {
        if (success !== true || id == null) {
            return;
        }

        this._state.tabs = [...this._state.tabs];

        _.each(this._state.tabs, (tab) => {
            if (tab.workspaceID !== id) {
                return;
            }

            tab.workspaceID = null;
        });

        this.navigateToTab(
            this._state.tabDisplay,
            this._state.tabs[this._state.tabDisplay] && this._state.tabs[this._state.tabDisplay].workspaceID,
            true
        );
    }

    private addTab() {
        this._state.tabs.push(AppStore.getEmptyTab(null));
        this._state.tabDisplay = this._state.tabs.length - 1;

        this.navigateToTab(this._state.tabDisplay);
    }

    private reorderTabs(start: number, stop: number) {
        if (start === stop) {
            return false;
        }

        const tabs = [...this._state.tabs];
        const item = tabs.splice(start, 1);

        tabs.splice(stop, 0, item[0]);

        if (start === this._state.tabDisplay) {
            this._state.tabDisplay = stop;
        } else if (start < this._state.tabDisplay && stop >= this._state.tabDisplay) {
            this._state.tabDisplay -= 1;
        } else if (start > this._state.tabDisplay && stop <= this._state.tabDisplay) {
            this._state.tabDisplay += 1;
        }

        this._state.tabs = tabs;
        this.navigateToTab(this._state.tabDisplay, null, true);

        return true;
    }

    private workspaceLoadContentFinish(id, success) {
        if (success === true) {
            return;
        }

        this.workspaceRemove(true, id);
    }

    private widgetEditShow() {
        this._state.showWidgetEdit = true;
    }

    private widgetEditHide() {
        this._state.showWidgetEdit = false;
    }

    // private userSettingsShow() {
    //     this._state.showUserSettingsView = true;
    // }

    // private userSettingsHide() {
    //     this._state.showUserSettingsView = false;
    // }

    private permissionsDirShow() {
        this._state.showDirPermissions = true;
    }

    private permissionsDirHide() {
        this._state.showDirPermissions = false;
    }

    private addHomeDir(userId, name) {
        const result = $.Deferred();
        this.glob.AQLQueries.callMethod<any>('dir_CreateHomeDir', {
            userid: userId,
            name: name,
            createHomeDir: true
        })
            .done(() => {
                this._state.homeFolderId = userId;
                this.glob.AppActions.showNotification_Success(' Home Dir succesfully added for ' + name + ' user.');
                result.resolve();
            })
            .fail((response) => {
                this.glob.AppActions.showNotification_Fail(
                    'Home Dir has not been added for ' + name + ' user. ' + response?.result?.message
                );
                result.reject();
            });
        return result;
    }

    private deleteHomeDir(userId) {
        const result = $.Deferred();
        this.glob.AQLQueries.callMethod<any>('dir_DeleteHomeDir', {
            userid: userId
        })
            .done(() => {
                this._state.homeFolderId = -1;
                this.glob.AppActions.showNotification_Success(' Home Dir succesfully deleted.');
                result.resolve();
            })
            .fail((response) => {
                this.glob.AppActions.showNotification_Fail(
                    'Home Dir has not been deleted. ' + response?.result?.message
                );
                result.reject();
            });
        return result;
    }

    private getHomeDir(userId) {
        const result = $.Deferred();
        this.glob.AQLQueries.callMethod<any>('workspace_GetHomeDir', {
            userid: userId ? userId : -1
        })
            .done((resp) => {
                this._state.homeFolderId = resp.result as number;
                result.resolve();
            })
            .fail((response) => {
                this._state.homeFolderId = -1;
                this.glob.AppActions.showNotification_Fail('Home Dir cannot been gotten. ' + response?.result?.message);
                result.reject();
            });
        return result;
    }

    private componentShow(moduleName: string, componentProps: any) {
        this._state.showComponent = true;
        this._state.componentModuleName = moduleName;
        this._state.componentProps = componentProps;
    }

    private setWidgetTabTheme(tab: number, theme: IValuesCollection) {
        let tabObj: ITab;

        if (tab == null) {
            tabObj = this.getCurrentTab();
        } else {
            tabObj = this._state.tabs[tab];
        }

        tabObj = { ...tabObj };
        tabObj.widgetTheme = theme;

        if (tab == null) {
            this.setCurrentTab(tabObj);
        } else {
            this._state.tabs[tab] = tabObj;
        }
    }

    public getCurrentUserId() {
        return this._state.authData.userid;
    }

    public handlePageVisibilityChange(isVisible: boolean) {
        if (this._state.pageIsVisible !== isVisible) {
            this._state.pageIsVisible = isVisible;

            return true;
        } else {
            return false;
        }
    }

    private syncConfigModule(data) {
        if (data == null) {
            return;
        }

        config.USERS_ADMIN_CAN_ENTER_PW = data['Authentication/AdminCanEnterPW'];
        config.USERS_EMAIL_AS_LOGIN = data['Authentication/UseEmailAsLogin'];
        config.USERS_PW_CAN_BE_RESENT = data['Authentication/PWCanBeResent'];
        config.USERS_PW_MIN_LENGTH = data['Authentication/PWMinLength'];
        config.USERS_PW_MUST_HAVE_MIXED_LETTER_CASE = data['Authentication/PWMustHaveMixedLetterCase'];
        config.USERS_PW_MUST_HAVE_NUMBERS_AND_LETTERS = data['Authentication/PWMustHaveNumbersAndLetters'];

        if (data['maxURLLen'] != null) {
            config.URL_MAX_LENGTH = data['maxURLLen'];
        }

        this.glob.AppActions.appSettingsApplyChanges();
    }

    private setWorkspaceContentChanged(tabID: number, widgetID: number, value: boolean): void {
        const tab = this.getTabInfo(tabID).tab;

        let result = false;

        if (tab != null) {
            if (value) {
                if (Array.isArray(tab.contentChanged)) {
                    if (tab.contentChanged.findIndex((id) => id === widgetID) < 0) {
                        tab.contentChanged.push(widgetID);
                        result = true;
                    }
                } else {
                    tab.contentChanged = [widgetID];
                    result = true;
                }
            } else if (Array.isArray(tab.contentChanged)) {
                const index = tab.contentChanged.findIndex((id) => id === widgetID);

                if (index >= 0) {
                    if (tab.contentChanged.length === 1) {
                        tab.contentChanged = null;
                    } else {
                        tab.contentChanged.splice(index, 1);
                    }

                    result = true;
                }
            }
        }

        if (result) {
            //EVG: It is wrong to refresh everything only to make a Tab Closing Cross red.
            // That is why I removed this.emitChange() for this and added a specific event.
            this.trigger(ON_TAB_CONTENT_STATE_CHANGED);
        }
    }

    private doDrillDown(workspace: number, drillDownParams) {
        // there can be a list of pairs {Drop Down WidgetID, Target Level} in dd options specification
        const ddkeys = _.without(_.keys(drillDownParams), 'query');

        _.each(ddkeys, (level) => {
            this.glob.AppActions.workspaceDoDrillDown(
                workspace,
                parseInt(level),
                drillDownParams[level],
                drillDownParams.query
            );
        });
    }

    // Drilldown should be applied when Workspace Instance is initiated and Attribute filter is created.
    private applyDrillDown(workspace: number, drillDownParams: any) {
        const instance = this.glob.WorkspaceStore.getInstanceState(workspace);

        if (instance != null) {
            if (instance.loading) {
                instance._defs.initialLoad.then((result) => {
                    this.doDrillDown(workspace, drillDownParams);
                });
            } else {
                this.doDrillDown(workspace, drillDownParams);
            }
        }
    }

    public addOnTabContentStateChangedListener(callback: Function) {
        this.on(ON_TAB_CONTENT_STATE_CHANGED, callback);
    }

    public removeOnTabContentStateChangedListener(callback: Function) {
        this.off(ON_TAB_CONTENT_STATE_CHANGED, callback);
    }

    protected eventsHandler(payload) {
        if (!super.eventsHandler(payload)) {
            return false;
        }

        const a = payload.action;
        const _case = checkAction;

        do {
            if (_case<I.UPDATE_TIME>(a, Constants.UPDATE_TIME)) {
                this.updateTime();
                this.emitChange();
                break;
            }

            if (_case<I.INITIAL_LOAD>(a, Constants.INITIAL_LOAD)) {
                this.initialLoad();
                this.emitChange();
                break;
            }

            if (_case<I.INITIAL_LOAD_FINISH>(a, Constants.INITIAL_LOAD_FINISH)) {
                this.initialLoadFinish(a.authorized);
                this.emitChange();
                break;
            }

            if (_case<I.SHOW_ERROR_FORM>(a, Constants.SHOW_ERROR_FORM)) {
                this.showErrorForm(a.error);
                this.emitChange();
                break;
            }

            if (_case<I.AUTH_FINISH>(a, Constants.AUTH_FINISH)) {
                this.authFinish(a.displayName, a.userid, a.userToken, a.picture);
                this.emitChange();
                break;
            }

            if (_case<I.MAIN_VIEW_SHOW>(a, Constants.MAIN_VIEW_SHOW)) {
                this.mainViewShow();
                this.emitChange();
                break;
            }

            if (_case<I.MAIN_VIEW_HIDE>(a, Constants.MAIN_VIEW_HIDE)) {
                this.mainViewHide();
                this.emitChange();
                break;
            }

            if (_case<I.TEMPLATES_EXPLORER_SHOW>(a, Constants.TEMPLATES_EXPLORER_SHOW)) {
                this.showDirsTemplates();
                this.emitChange();
                break;
            }

            if (_case<I.TEMPLATES_EXPLORER_HIDE>(a, Constants.TEMPLATES_EXPLORER_HIDE)) {
                this.hideDirsTemplates();
                this.emitChange();
                break;
            }

            if (_case<I.WORKSPACES_EXPLORER_SHOW>(a, Constants.WORKSPACES_EXPLORER_SHOW)) {
                this.showDirsWorkspaces();
                this.emitChange();
                break;
            }

            if (_case<I.WORKSPACES_EXPLORER_HIDE>(a, Constants.WORKSPACES_EXPLORER_HIDE)) {
                this.hideDirsWorkspaces();
                this.emitChange();
                break;
            }

            if (_case<I.WORKSPACE_SHOW>(a, Constants.WORKSPACE_SHOW)) {
                this.workspaceShow();
                this.emitChange();
                break;
            }

            if (_case<I.WORKSPACE_HIDE>(a, Constants.WORKSPACE_HIDE)) {
                this.workspaceHide(a.id);
                this.emitChange();
                break;
            }

            if (_case<I.WORKSPACE_VIEW_SHOW>(a, Constants.WORKSPACE_VIEW_SHOW)) {
                this.workspaceViewShow(a.id);
                this.emitChange();
                break;
            }

            if (_case<I.WORKSPACE_VIEW_HIDE>(a, Constants.WORKSPACE_VIEW_HIDE)) {
                this.workspaceViewHide(a.id);
                this.emitChange();
                break;
            }

            if (_case<IW.WORKSPACE_VIEW_OPEN>(a, Constants.WORKSPACE_VIEW_OPEN)) {
                this.workspaceViewOpen(a.id, a.tab, a.widgetID, a.originTab, a.options, a.theme, a.query);
                this.emitChange();
                break;
            }

            if (_case<I.WORKSPACE_WIDGET_VIEW_OPEN>(a, Constants.WORKSPACE_WIDGET_VIEW_OPEN)) {
                this.workspaceWidgetViewOpen(a.workspace, a.widget, a.stateId, a.data, a.query);
                this.emitChange();
                break;
            }

            if (_case<I.WORKSPACE_VIEW_CLOSE>(a, Constants.WORKSPACE_VIEW_CLOSE)) {
                this.workspaceViewClose(a.id, a.tabIndex, a.clearWorkspaceCache, a.doNotCloseTab);
                this.emitChange();
                break;
            }

            if (_case<I.CLOSE_ALL_OPENED_TABS>(a, Constants.CLOSE_ALL_OPENED_TABS)) {
                if (this.closeAllOpenedTabs(a.exceptTabIndex, a.closeToTheRight)) {
                    this.emitChange();
                }
                break;
            }

            if (_case<I.WORKSPACE_BEFORE_CLOSE>(a, Constants.WORKSPACE_BEFORE_CLOSE)) {
                this.workspaceBeforeClose(a.id, a.tabIndex);
                this.emitChange();
                break;
            }

            if (_case<I.TEMPLATE_SHOW>(a, Constants.TEMPLATE_SHOW)) {
                this.templateShow(a.id);
                this.emitChange();
                break;
            }

            if (_case<I.TEMPLATE_HIDE>(a, Constants.TEMPLATE_HIDE)) {
                this.templateHide(a.id);
                this.emitChange();
                break;
            }

            if (_case<I.WORKSPACE_DELETE_FINISH>(a, Constants.WORKSPACE_DELETE_FINISH)) {
                this.workspaceRemove(a.success, a.id);
                this.emitChange();
                break;
            }

            if (_case<I.ADD_TAB>(a, Constants.ADD_TAB)) {
                this.addTab();
                this.emitChange();
                break;
            }

            if (_case<I.REORDER_TABS>(a, Constants.REORDER_TABS)) {
                if (this.reorderTabs(a.start, a.stop)) {
                    this.emitChange();
                }
                break;
            }

            if (_case<I.WORKSPACE_VIEW_CONTENT_LOAD_FINISH>(a, Constants.WORKSPACE_VIEW_CONTENT_LOAD_FINISH)) {
                this.workspaceLoadContentFinish(a.id, a.success);
                this.emitChange();
                break;
            }

            if (_case<I.WIDGET_EDIT_SHOW>(a, Constants.WIDGET_EDIT_SHOW)) {
                this.widgetEditShow();
                this.emitChange();
                break;
            }

            if (_case<I.WIDGET_EDIT_HIDE>(a, Constants.WIDGET_EDIT_HIDE)) {
                this.widgetEditHide();
                this.emitChange();
                break;
            }

            // if (_case<I.USER_SETTINGS_SHOW>(a, Constants.USER_SETTINGS_SHOW)) {
            //     this.userSettingsShow();
            //     this.emitChange();
            //     break;
            // }

            // if (_case<I.USER_SETTINGS_HIDE>(a, Constants.USER_SETTINGS_HIDE)) {
            //     this.userSettingsHide();
            //     this.emitChange();
            //     break;
            // }

            if (_case<I.PERMISSIONS_DIR_SHOW>(a, Constants.PERMISSIONS_DIR_SHOW)) {
                this.permissionsDirShow();
                this.emitChange();
                break;
            }

            if (_case<I.ADD_HOME_DIR>(a, Constants.ADD_HOME_DIR)) {
                this.addHomeDir(a.userid, a.name).done(() => {
                    this.emitChange();
                });
                break;
            }

            if (_case<I.DELETE_HOME_DIR>(a, Constants.DELETE_HOME_DIR)) {
                this.deleteHomeDir(a.userid).done(() => {
                    this.emitChange();
                });
                break;
            }
            if (_case<I.GET_HOME_DIR>(a, Constants.GET_HOME_DIR)) {
                this.getHomeDir(a.userid).done(() => {
                    this.emitChange();
                });
                break;
            }
            if (_case<I.PERMISSIONS_DIR_HIDE>(a, Constants.PERMISSIONS_DIR_HIDE)) {
                this.permissionsDirHide();
                this.emitChange();
                break;
            }

            if (_case<I.COMPONENT_SHOW>(a, Constants.COMPONENT_SHOW)) {
                this.componentShow(a.moduleName, a.componentProps);
                this.emitChange();
                break;
            }
            if (_case<I.UNAUTHORIZED>(a, Constants.UNAUTHORIZED)) {
                this.unauthorized();
                this.emitChange();
                break;
            }

            if (_case<I.SET_WIDGET_TAB_THEME>(a, Constants.SET_WIDGET_TAB_THEME)) {
                this.setWidgetTabTheme(a.tab, a.theme);
                this.emitChange();
                break;
            }

            if (_case<I.PAGE_VISIBILITY_CHANGE>(a, Constants.PAGE_VISIBILITY_CHANGE)) {
                this.emitChange(this.handlePageVisibilityChange(a.isVisibile));
                break;
            }

            if (
                _case<I.APP_SETTINGS_GET_FINISH>(a, Constants.APP_SETTINGS_GET_FINISH) ||
                _case<I.APP_SETTINGS_GET_DEFAULT_THEME_FINISH>(a, Constants.APP_SETTINGS_GET_DEFAULT_THEME_FINISH)
            ) {
                this.syncConfigModule(a.data);
                break;
            }

            if (_case<I.WORKSPACE_RESET_FINISH>(a, Constants.WORKSPACE_RESET_FINISH)) {
                this.emitChange();
                break;
            }

            if (_case<I.SET_WORKSPACE_CONTENT_CHANGED>(a, Constants.WORKSPACE_SET_CONTENT_CHANGED)) {
                this.setWorkspaceContentChanged(a.tabId, a.widget, a.contentChanged);
                break;
            }

            if (_case<I.DROP_WORKSPACE_QUERY>(a, Constants.DROP_WORKSPACE_QUERY)) {
                this.dropWorkspaceQuery(a.tabID);
                break;
            }
        } while (false);

        return true;
    }

    public static _name: string = 'app';

    constructor(glob: IGlobalObject, dispatcher: Dispatcher, actions: AppActions) {
        super(glob, dispatcher, actions, AppStore._name);

        this._state = _.extend(AppStore.getInitialState(), this._state);
    }

    static get(glob, dispatcher: Dispatcher, actions: AppActions) {
        return new AppStore(glob, dispatcher, actions);
    }
}
